import type { IAccountSettingsResources } from "@/src/settings/AccountSettings.Resources";

export const AccountSettingsResourcesEn: IAccountSettingsResources = {
    changePassword: "Change password",
    changeEmailAddress: "Change email address",
    changeEmailSuccessDescription:
        "Verification link has been sent to the provided email address. It will be active for the next 24hrs. If you don't verify new email address the change won't be saved.",
    changeEmailSuccessHeader: "Check your inbox!",
    saveChanges: "Save changes",
    verifyEmailAddress: "Verify email address",

    birthDateLabel: "Date of birth",
    birthDatePlaceholder: "DD.MM.YYYY",
};
